<template>
	<div>
		<div class="answer-block">
			<h1 role="alert" aria-live="assertive" tabindex="0" class="ada-focus">I’m missing an item</h1>

			<div v-if="condition !== 'exchange'">
				<p v-if="status === 'will_ship_soon'">
					This has not yet shipped, but will soon!
				</p>

				<div v-else-if="status === 'will_deliver_soon'">
					<p>
						This will deliver soon, see <a class="help-link" :href="tracking_url" v-if="tracking_url" target="_blank">tracking</a><span v-if="!tracking_url">tracking</span> for an estimated delivery date.
					</p>

					<div class="h-email-form">
						<email-form
								caption="Email us"
								subject="Item Lost in Transit"
								:body="getBody()"
								on-success-url="/help?#/submitted"
								edit-body
								:payload="{order_line_id: order_line_id, has_attachment: true}"
								destination-key="cs"
						></email-form>
					</div>
				</div>
				<div v-else-if="status === 'delivered'">
					<div class="h-email-form">
						<email-form
								caption="Email us"
								subject="I have not received my item"
								:body="getBody()"
								on-success-url="/help?#/submitted"
								edit-body
								:payload="{order_line_id: order_line_id, has_attachment: true}"
								destination-key="cs"
						></email-form>
					</div>
				</div>
			</div>
			<div v-else>
				<p>
					Please <a class="help-link" :href="`/account/new_messages.php?action=thread&type=postsale&item_id=${parseInt($route.params.id)}#lastmessage`">message your
					seller</a>
					and let them know there was an issue
				</p>

				<p v-if="!spoke_to_seller">
					<v-btn @click="spoke_to_seller = true">I already messaged the seller and got no response</v-btn>
				</p>

				<email-form
						caption="Contact Us"
						v-if="spoke_to_seller"
						subject="Marketplace Item Lost in Transit"
						body="I already messaged the seller and got no response"
						on-success-url="/help?#/submitted"
						edit-body
						:payload="{order_line_id: order_line_id, has_attachment: true}"
						destination-key="cs"
				></email-form>
			</div>

		</div>

		<base-nav-links></base-nav-links>
	</div>
</template>

<script>
	import BaseNavLinks from './../../../components/BaseNavLinks';
	import EmailForm from './../../../components/EmailForm';
	import Axios from 'axios';

	export default {
		name: "MissingItem",

		components: {
			BaseNavLinks,
			EmailForm,
		},

		data() {
			return {
				loading: false,
				spoke_to_seller: false,
				status: null,
				order_line_id: null,
				order_id: null,
				condition: null,
				isbn: null,
				tracking_url: null
			}
		},

		mounted() {
			const self = this;
			self.loading = true;

			Axios.get('/service/customer_help/rest/index.php/customer_help/get_shipping_status/' + parseInt(self.$route.params.id))
				.then(function (response) {
					if (response.status === 200 && response.data && response.data['status'] === 'success') {
						let d = response['data']['data'];
						self.status = d['status'];
						self.order_id = d['order_id'];
						self.condition = d['condition'];
						self.order_line_id = parseInt(self.$route.params.id);
						self.isbn = d['isbn'];
						self.tracking_url = d['tracking_url'];
					}
				})
				.finally(function () {
					self.loading = false;
				});
		},

		methods: {
			getBody() {
				switch (this.status) {
					case 'will_deliver_soon':
						return 'I have not received my item, and the tracking shows it is lost in transit.';
					case 'delivered':
						return 'I have not received my item, and the tracking shows it has delivered.';
				}

				return '';
			},
		}
	}
</script>

<style scoped lang="less">
	.h-email-form {
		margin-top: 20px;
	}
</style>